// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__JRV2r","breadcrumb":"Breadcrumbs_breadcrumb__3dhF0"};